import React, { useState } from 'react';
import {
  Button,
  ButtonDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';
import { Icon } from '../Icon';

export interface DropdownActionOption {
  title: string;
  description: string;
  action: () => void;
}

interface PropTypes {
  label: string;
  color?: string;
  disabled?: boolean;
  direction?: 'up' | 'down';
  options: DropdownActionOption[];
}

export function DropdownActionButton(props: PropTypes) {
  const [isOpen, setIsOpen] = useState(false);
  const color = props.color ?? 'success';
  const primaryAction = props.options[0]?.action;

  return (
    <ButtonDropdown
      isOpen={isOpen}
      toggle={() => setIsOpen(!isOpen)}
      direction={props.direction ?? 'down'}
    >
      <Button
        color={color}
        disabled={props.disabled || props.options.length === 0}
        onClick={primaryAction}
        className='rounded-end-0'
      >
        {props.label}
      </Button>
      <DropdownToggle
        color={color}
        disabled={props.disabled}
        className='rounded-start-0 border-start border-light px-2'
      >
        <Icon
          name='bi-chevron-down'
          className='fs-5'
          style={{
            transition: 'transform 0.2s ease',
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            display: 'inline-block',
          }}
        />
      </DropdownToggle>
      <DropdownMenu style={{ minWidth: '320px' }}>
        {props.options.map((option, index) => (
          <DropdownItem
            key={index}
            onClick={option.action}
            disabled={props.disabled}
            style={{ whiteSpace: 'normal' }}
            className='py-2'
          >
            <div className='fw-bold'>{option.title}</div>
            <div className='fs-6 text-muted'>{option.description}</div>
          </DropdownItem>
        ))}
      </DropdownMenu>
    </ButtonDropdown>
  );
}
